import { useAuthenticationStore } from '@cplug/frontend-shared-domains/domain/authentication'
import { beginSessionRestore, finalizeSessionRestore } from './useSessionRestoreState'

let consumedRefreshToken: string | undefined
let handoffResult: Promise<boolean> | undefined

/**
 * Troca o refresh token da URL por cookie via `applyUrlHandoffSession`.
 *
 * O Nuxt reprocessa a URL inicial mais de uma vez, então o latch garante uma
 * única troca por token. Revogação, sonda e restauração do bearer ficam na store.
 */
export function useLegacyHandoff (refreshToken: string): Promise<boolean> {
  if (handoffResult != null && consumedRefreshToken === refreshToken) {
    return handoffResult
  }

  consumedRefreshToken = refreshToken
  beginSessionRestore()

  handoffResult = useAuthenticationStore()
    .applyUrlHandoffSession(refreshToken)
    .catch(() => false)
    .then((succeeded: boolean) => {
      finalizeSessionRestore(succeeded)

      return succeeded
    })

  return handoffResult
}

export function getLegacyHandoffResult (): Promise<boolean> | undefined {
  return handoffResult
}

export function resetLegacyHandoffState (): void {
  consumedRefreshToken = undefined
  handoffResult = undefined
}
